import { render, staticRenderFns } from "./IllustrationBanner.vue?vue&type=template&id=9f5fb360&scoped=true"
var script = {}
import style0 from "./IllustrationBanner.vue?vue&type=style&index=0&id=9f5fb360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5fb360",
  null
  
)

export default component.exports